import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';
import { from, of } from 'rxjs';
import { concatMap, delay, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-send-reminder-letter-issue',
  templateUrl: './send-reminder-letter-issue.component.html',
  styleUrl: './send-reminder-letter-issue.component.scss'
})
export class SendReminderLetterIssueComponent {

  currentDate: Date;
  getpendingreceipt: any;
  PendingReceiptAmt: number;
  PendingBalanceAmt: number;
  isEditMode: boolean = false;
  isSaving: boolean = false;

  // Add these new properties for address and advt_name
  advtName: string = '';
  advtAddress: string = '';

  // GROUPED DATA used for WhatsApp sending (same role as "letters" in the book component)
  letters: any[] = [];
  sendingAllWhatsApp: boolean = false;

  // Dynamic letter body text
  letterBodyText = {
    template_name: 'send-reminder1',
    subject_line: '',
    greeting: '',
    paragraph1: '',
    paragraph2: '',
    paragraph3: '',
    details_heading: '',
    closing_text: ''
  };

  // Default text (fallback if API fails or no data)
  defaultLetterText = {
    template_name: 'send-reminder1',
    subject_line: 'विषय : मागील अंक/ग्रंथ येणे बाकी संदर्भात स्मरणपत्र .........',
    greeting: 'सस्नेह नमस्कार',
    paragraph1: 'सा.विवेक हे महाराष्ट्रातील सर्व महत्वाच्या घडामोडींचा आढावा घेणारे वैचारिक साप्ताहिक आहे. प्रसारमाध्यमातून सामाजिक परिवर्तनाचे राष्ट्रीय कार्य गेली 78 वर्षे अखंडितपणे सुरू आहे. हा प्रवास आपल्याकडून सा.विवेकला वेळोवेळी मिळत असलेल्या अर्थपूर्ण सहकार्यामुळेच शक्य होत आहे. यासाठी आपले मनःपूर्वक धन्यवाद !',
    paragraph2: 'आपण जाणताच की, कोणत्याही राजकीय अथवा मोठ्या औद्योगिक समूहाचे आर्थिक पाठबळ नसताना विवेक केवळ आपल्यासारख्या राष्ट्रभक्त हितचिंतकांच्या आश्वासक पाठिंब्यामुळेच सुरू आहे. याचा विवेक समूहाला सार्थ अभिमान आहे. मागील अंकात आपली, आपल्या आस्थापनाची जाहिरात प्रकाशित करण्यात आली होती. मात्र ही देय रक्कम कार्यालयात अद्याप जमा झालेली नाही.',
    paragraph3: 'अशा प्रकारची देय रक्कम कार्यालयात जमा न होणे हे प्रसारमाध्यम क्षेत्रात काम करणाऱ्या विवेकसारख्या सामाजिक संस्थेला परवडणारे नसते, हे आपण जाणताच! आपली देय रक्कम आपल्या व्यग्र कामकाजामुळे राहून गेली असावी असे आम्हाला वाटते. तरी आपणास नम्र विनंती आहे की, ही देय रक्कम कार्यालयात लवकरात लवकर जमा करावी. धन्यवाद !',
    details_heading: 'येणे बाकी तपशील खालील प्रमाणे आहे.',
    closing_text: ''
  };

  constructor(
    private dialogRef: MatDialogRef<SendReminderLetterIssueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private datePipe: DatePipe
  ) {}

  reportType: any;
  startDate: any;
  endDate: any;
  repName: any;
  offRepName: any;
  issueDates: any;
  issueDates1: any;

  OutStandingIDTotal: number = 0;
  OutStandingIDNetAmtTotal: number = 0;
  OutStandingIDUnPaidTotal: number = 0;

  ngOnInit(): void {
    this.currentDate = new Date();

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'] || this.data['advt_name'] || '';
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];

    // Load letter template from backend
    this.loadLetterTemplate();

    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "off_rep_name": this.offRepName,
      "advt_name": this.advtName,
      "issue_name": "",
      "issue_date": this.issueDates1
    }

    this.service.getpendingreceiptRepissue(req).subscribe((data: any) => {
      this.getpendingreceipt = data as any;
      console.log("pending receipt", data)

      // Extract address from first record if available
      if (this.getpendingreceipt && this.getpendingreceipt.length > 0) {
        this.advtAddress = this.getpendingreceipt[0].address ||
                          this.getpendingreceipt[0].advt_address || '';
        // Update advtName if not already set
        if (!this.advtName && this.getpendingreceipt[0].advt_name) {
          this.advtName = this.getpendingreceipt[0].advt_name;
        }
      }

      // Reset totals
      this.PendingReceiptAmt = 0;
      this.PendingBalanceAmt = 0;

      // Calculate totals
      for (let data1 of this.getpendingreceipt) {
        this.PendingReceiptAmt += parseInt(data1.advt_amt) || 0;
        this.PendingBalanceAmt += parseInt(data1.remain_amt) || 0;
      }

      // BUILD "letters" — grouped per advertiser, same shape the book component
      // uses (booksellername/district/mobile/totalInvoice/totalBalance) so the
      // WhatsApp send logic below can stay identical to the book component.
      const records = (this.getpendingreceipt || []).map((item: any) => ({
        advt_name: item.advt_name || this.advtName,
        address: item.address || item.advt_address || this.advtAddress || '',
        mobile: item.mobile_no || item.mobile || item.advt_mobile || '',
        advt_amt: Number(item.advt_amt) || 0,
        remain_amt: Number(item.remain_amt) || 0
      }));

      const grouped: any = {};

      records.forEach((r: any) => {
        const key = r.advt_name || 'unknown';

        if (!grouped[key]) {
          grouped[key] = {
            booksellername: r.advt_name,   // kept as "booksellername" so buildWhatsAppReminderPayload() below matches the book component exactly
            district: r.address,
            mobile: r.mobile,
            totalInvoice: 0,
            totalBalance: 0
          };
        }

        // Keep the first non-empty mobile number found for this advertiser
        if (!grouped[key].mobile && r.mobile) {
          grouped[key].mobile = r.mobile;
        }

        grouped[key].totalInvoice += r.advt_amt;
        grouped[key].totalBalance += r.remain_amt;
      });

      this.letters = Object.values(grouped);

      this.cdr.detectChanges();
    });
  }

  /**
   * Load letter template from backend
   */
  loadLetterTemplate(): void {
    this.service.getLetterTemplateissueseller('send-reminder1').subscribe(
      (response: any) => {
        console.log('Letter template response:', response);

        if (response && response.success && response.data) {
          const data = response.data;

          this.letterBodyText = {
            template_name: data.template_name || 'send-reminder1',
            subject_line: data.subject_line || this.defaultLetterText.subject_line,
            greeting: data.greeting || this.defaultLetterText.greeting,
            paragraph1: data.paragraph1 || this.defaultLetterText.paragraph1,
            paragraph2: data.paragraph2 || this.defaultLetterText.paragraph2,
            paragraph3: data.paragraph3 || this.defaultLetterText.paragraph3,
            details_heading: data.details_heading || this.defaultLetterText.details_heading,
            closing_text: data.closing_text || this.defaultLetterText.closing_text
          };
        } else {
          console.log('No template found, using default');
          this.letterBodyText = { ...this.defaultLetterText };
        }
        this.cdr.detectChanges();
      },
      (error) => {
        console.error('Error loading letter template:', error);
        this.letterBodyText = { ...this.defaultLetterText };
        this.cdr.detectChanges();
      }
    );
  }

  /**
   * Toggle edit mode on/off
   */
  toggleEditMode(): void {
    this.isEditMode = !this.isEditMode;

    if (!this.isEditMode) {
      this.loadLetterTemplate();
    }
  }

  /**
   * Save letter template to backend
   */
  saveLetterTemplate(): void {
    if (!this.letterBodyText.template_name) {
      alert('टेम्पलेट नाव आवश्यक आहे!');
      return;
    }

    this.isSaving = true;

    this.service.saveLetterTemplateissue(this.letterBodyText).subscribe(
      (response: any) => {
        console.log('Letter template saved successfully', response);
        this.isSaving = false;

        if (response && response.success) {
          alert('पत्र टेम्पलेट यशस्वीरित्या जतन केले! (Template saved successfully!)');
          this.isEditMode = false;
          this.cdr.detectChanges();
        } else {
          alert('त्रुटी: ' + (response.message || 'टेम्पलेट जतन करताना त्रुटी'));
        }
      },
      (error) => {
        console.error('Error saving letter template:', error);
        this.isSaving = false;
        alert('पत्र टेम्पलेट जतन करतानाची त्रुटी! (Error saving template!)');
      }
    );
  }

  /* ================= WHATSAPP SENDING (ported from book component) ================= */

  formatDate(date: Date): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

private buildWhatsAppReminderPayload(letter: any): { mobile: string; campaignName: string; templateParams: string[] } | null {

  if (!letter?.mobile) {
    return null;
  }

  // Normalize to a plain 10-digit string. Do NOT prefix a country code here —
  // the backend (send_wp_msg_using_aisensy.php) already adds "91" itself,
  // so doing it here as well produces a malformed double-prefixed number.
  let mobileDigits = String(letter.mobile).replace(/\D/g, '');
  if (mobileDigits.length > 10) {
    mobileDigits = mobileDigits.slice(-10); // in case a code somehow got included, keep last 10 digits
  }
  if (mobileDigits.length !== 10) {
    return null; // invalid mobile number, skip rather than send a broken payload
  }

  return {
    mobile: mobileDigits,
    campaignName: 'yeneissue',
    // Must match the AiSensy-approved template exactly:
    // {{1}} name, {{2}} date, {{3}} amount — no area/district variable.
    templateParams: [
      letter.booksellername,
      this.formatDate(this.currentDate),
      Number(letter.totalBalance).toFixed(2)
    ]
  };
}

  // ================= SEND SINGLE REMINDER =================
  sendWhatsAppReminder(letter: any): void {

    if (!letter) {
      alert('Letter data not found');
      return;
    }

    const payload = this.buildWhatsAppReminderPayload(letter);

    if (!payload) {
      alert('Mobile number not found for ' + letter.booksellername);
      return;
    }

    letter.isSendingWhatsApp = true;

    this.service.sendWhatsAppReceipt(payload).subscribe({
      next: () => {
        letter.isSendingWhatsApp = false;
        alert('WhatsApp sent successfully');
        letter.isWhatsAppSent = true;
      },
      error: (err: any) => {
        letter.isSendingWhatsApp = false;
        console.error('WhatsApp failed:', err);
        alert('WhatsApp failed');
      }
    });
  }

  // ================= SEND ALL REMINDERS (bulk, one-shot) =================
  sendAllWhatsAppReminders(): void {

    if (!this.letters.length) {
      alert('पाठवण्यासाठी कोणतेही रेकॉर्ड उपलब्ध नाहीत.');
      return;
    }

    if (!confirm(`सर्व ${this.letters.length} जाहिरातदारांना स्मरणपत्र WhatsApp पाठवायचे आहे का?`)) return;

    const skipped: string[] = [];
    const failed: string[] = [];
    const sent: string[] = [];

    const jobs = this.letters
      .filter(l => !l.isWhatsAppSent) // don't re-send to ones already marked sent
      .map(letter => ({ letter, payload: this.buildWhatsAppReminderPayload(letter) }))
      .filter(job => {
        if (!job.payload) {
          skipped.push(job.letter.booksellername);
          return false;
        }
        return true;
      });

    if (!jobs.length) {
      alert('कोणत्याही अंक/ग्रंथ ग्राहक वैध मोबाईल नंबर उपलब्ध नाही.');
      return;
    }

    this.sendingAllWhatsApp = true;
    jobs.forEach(job => job.letter.isSendingWhatsApp = true);

    from(jobs).pipe(
      concatMap(job =>
        this.service.sendWhatsAppReceipt(job.payload!).pipe(
          delay(400), // gap between sends to avoid rate-limiting
          catchError(err => {
            console.error(`WhatsApp failed for ${job.letter.booksellername}:`, err);
            failed.push(job.letter.booksellername);
            return of(null);
          }),
          concatMap(res => {
            job.letter.isSendingWhatsApp = false;
            if (res !== null) {
              job.letter.isWhatsAppSent = true;
              sent.push(job.letter.booksellername);
            }
            return of(res);
          })
        )
      )
    ).subscribe({
      complete: () => {
        this.sendingAllWhatsApp = false;
        this.cdr.detectChanges();

        let msg = `✅ पाठवले: ${sent.length}`;
        if (failed.length) msg += `\n❌ अयशस्वी: ${failed.length} (${failed.join(', ')})`;
        if (skipped.length) msg += `\n⚠️ मोबाईल नंबर नाही: ${skipped.length} (${skipped.join(', ')})`;

        alert(msg);
      }
    });
  }

  /**
   * Reset to default template
   */
  resetToDefault(): void {
    if (confirm('तुम्हाला खरोखर डिफॉल्ट टेम्पलेट रीसेट करायचे आहे का? (Do you want to reset to default template?)')) {
      this.letterBodyText = { ...this.defaultLetterText };
      this.saveLetterTemplate();
    }
  }

  /**
   * Update specific field
   */
  updateLetterField(field: string, value: string): void {
    if (this.letterBodyText.hasOwnProperty(field)) {
      this.letterBodyText[field] = value;
    }
  }

  /**
   * Export to Excel
   */
  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

  show = false

  printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
             @page {
  size: A4 portrait;
  margin: 5mm;
}
              .reminder-container {
    max-width: 210mm;
    margin: 0 auto;
    padding: 20px;
    border: 2px solid #000;
    background: #fff;
    font-family: 'Noto Sans Devanagari', Arial, sans-serif;
    color: #000 !important;
}

/* Header Section */
.header-section {
    padding-bottom: 15px;
    color: #000 !important;
}

.header-content {
    color: #000 !important;
}

.header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}

.organization-info {
    flex: 1;
    text-align: right;
    line-height: 1.6;
    margin-right: 55px;
}

.organization-name {
    font-size: 20px;
    font-weight: bold;
    margin: 0 0 5px 0;
    color: #000;
    text-align: right;
    margin-right: 3px;
}

.registration-number {
    font-size: 13px;
    color: #000 !important;
    margin-right: 55px;
    text-align: right;
    margin: 0 0 5px 0;
}

.header-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    margin-left: 20px;
}

.header-logo img {
    margin-right: 50px;
    max-width: 190px;
    margin-top: 12px;
}

.header-divider {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #333;
}

.office-details-single {
    font-size: 13px;
    line-height: 1.6;
    color: #000 !important;
    text-align: left;
}

.office-label {
    font-weight: bold;
    color: #000 !important;
}

.contact-label {
    font-weight: bold;
    color: #000 !important;
    margin-left: 188px;
}

/* Recipient Section */
.recipient-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 20px 0;
}

.recipient-address {
    text-align: left;
}

.date-section {
    padding-left: 20px;
    text-align: right;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    color: #000 !important;
}

.field-label {
    font-weight: bold;
    font-size: 15px;
}

.field-row {
    margin: 8px 0;
    font-size: 14px;
}

.field-value {
    font-size: 14px;
}

/* Content Section */
.content-section {
    padding: 20px 0;
    text-align: left;
}

.subject-line {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
    color: #000 !important;
}

.greeting {
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 15px;
}

.letter-body {
    font-size: 14px;
    line-height: 1.8;
    text-align: justify;
    color: #000 !important;
}

.letter-body p {
    margin: 12px 0;
    text-indent: 40px;
    color: #000 !important;
}

.details-heading {
    font-weight: bold;
    margin-top: 20px !important;
    color: #000 !important;
}

/* Table Section */
.table-wrapper {
    margin: 20px 0;
    overflow-x: auto;
    color: #000 !important;
}

.details-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    color: #000 !important;
}

.details-table th,
.details-table td {
    border: 1px solid #333;
    padding: 10px;
    text-align: center;
    color: #000 !important;
}

.details-table th {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 14px;
    color: #000 !important;
}

.details-table tbody tr:hover {
    background-color: #f9f9f9;
    color: #000 !important;
}

.total-row {
    font-weight: bold;
    background-color: #f5f5f5;
    color: #000 !important;
}

.closing-text {
    margin: 20px 0;
    font-size: 14px;
    text-indent: 40px;
}

.signature-section {
    text-align: right;
    margin: 40px 0 60px 0;
    font-size: 14px;
}

.signature-section p {
    margin: 5px 0;
}

/* Footer Section */
.footer-section {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding-top: 15px;
    border-top: 2px solid #000;
}

.footer-note {
    font-weight: bold;
    font-size: 15px;
    text-align: left;
}

.footer-signature {
    font-weight: bold;
    font-size: 15px;
    text-align: right;
}
          </style>
        </head>
        <body>
          <div id="print-section">
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}